"use client";

import { useEffect, useLayoutEffect } from "react";

/**
 * Effect that runs BEFORE the browser paints on the client.
 *
 * `useLayoutEffect` fires during the commit phase, so state written (and
 * notifications emitted) inside it — including microtask continuations such
 * as the mount flow's `storage:read` + optimistic `s:set` chain — are flushed
 * synchronously before the first frame composes. A passive `useEffect` runs
 * after that frame, which is why cache-first rendering painted one
 * placeholder frame (or missed the notifications entirely) before.
 *
 * On the server this degrades to `useEffect` so SSR'd client components do
 * not trip React's "useLayoutEffect does nothing on the server" warning.
 * The branch is evaluated once at module scope, so hook order is stable
 * across every render of a given environment.
 */
export const usePrePaintEffect =
  typeof window !== "undefined" ? useLayoutEffect : useEffect;